import { CartAddEvent } from '@theme/events';

const controllerKey = Symbol.for('pawlume.landing.controller');
function initialize() {
  window[controllerKey]?.abort();
  const controller = new AbortController();
  window[controllerKey] = controller;
  const { signal } = controller;
  const root = document.querySelector('[data-lc-page]');
  if (!root) return;
  const counters = document.querySelectorAll('[data-lc-count]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const counterObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      counterObserver.unobserve(entry.target);
      const target = Number(entry.target.dataset.lcCount);
      if (reducedMotion || target === 0) return;
      const started = performance.now();
      const tick = now => {
        if (signal.aborted) return;
        const progress = Math.min((now - started) / 1100, 1);
        entry.target.textContent = Math.round(target * (1 - Math.pow(1 - progress, 3)));
        if (progress < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    });
  }, {threshold: 0.6});
  counters.forEach(el => counterObserver.observe(el));
  signal.addEventListener('abort', () => counterObserver.disconnect(), {once: true});
  const variants = JSON.parse(root.querySelector('[data-lc-variants]').textContent);
  const all = (selector) => [...document.querySelectorAll(selector)];
  let variant = variants.find(v => String(v.id) === root.querySelector('[name="id"]').value) || variants[0];
  let quantity = Number(root.querySelector('[name="quantity"]').value) || 3;
  let busy = false;
  const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:root.dataset.currency || 'USD'});
  const money = value => formatter.format(value / 100);
  const paid = count => ({1:1,3:2,5:3})[count];
  const sync = () => {
    all('[data-lc-form]').forEach(form => {
      form.querySelector('[name="id"]').value = variant.id;
      form.querySelector('[name="quantity"]').value = quantity;
      form.querySelectorAll('input[type="radio"]').forEach(input => {
        input.checked = Number(input.value) === quantity;
        input.closest('.lc-bundle-card').classList.toggle('is-selected',input.checked);
      });
      const select = form.querySelector('[data-lc-variant]');
      if (select) select.value = String(variant.id);
    });
    [1,3,5].forEach(count => {
      const total = variant.price * paid(count);
      all(`[data-lc-price="${count}"]`).forEach(el=>el.textContent=money(total));
      all(`[data-lc-unit="${count}"]`).forEach(el=>el.textContent=money(total/count));
      all(`[data-lc-save="${count}"]`).forEach(el=>el.textContent=money(variant.price*count-total));
      all(`[data-lc-regular="${count}"]`).forEach(el=>el.textContent=money(variant.price*count));
    });
    all('[data-lc-total]').forEach(el=>el.textContent=money(variant.price*paid(quantity)));
    all('[data-lc-selected-label]').forEach(el=>el.textContent=quantity===1?'1 bottle · Starter':`${quantity} bottles · Buy ${paid(quantity)} get ${quantity-paid(quantity)}`);
    all('[data-lc-label]').forEach(el=>el.textContent=busy?'ADDING…':variant.available?root.dataset.cta:'Sold out');
    all('[data-lc-atc], [data-lc-sticky-button]').forEach(el=>{el.disabled=busy||!variant.available;el.setAttribute('aria-busy',String(busy));});
  };
  const listen = (el,event,fn,options={}) => el?.addEventListener(event,fn,{...options,signal});
  all('[data-lc-form]').forEach(form=>{
    listen(form,'change',event=>{
      if(event.target.matches('input[type="radio"]')) quantity=Number(event.target.value);
      if(event.target.matches('[data-lc-variant]')) {
        variant=variants.find(v=>String(v.id)===event.target.value)||variant;
        const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
        if(variant.featured_media){const slide=root.querySelector(`[data-media="${variant.featured_media.id}"]`);if(slide)gallery.scrollTo({left:slide.offsetLeft-gallery.offsetLeft,behavior:'smooth'});}
      }
      sync();
    });
    listen(form,'submit',async event=>{
      event.preventDefault(); if(busy || !variant.available)return;
      busy=true;sync();const error=form.querySelector('[data-lc-error]');error.hidden=true;
      try {
        const sectionIds=[...new Set(all('cart-items-component').map(el=>el.dataset.sectionId).filter(Boolean))];
        const body=new FormData(form);body.set('quantity',String(quantity));body.set('id',String(variant.id));
        for(const key of [...body.keys()]) if(key.startsWith('lc-offer-'))body.delete(key);
        if(sectionIds.length)body.set('sections',sectionIds.slice(0,5).join(','));
        body.set('sections_url',location.pathname);
        const base=window.Shopify?.routes?.root || '/';
        const response=await fetch(`${base}cart/add.js`,{method:'POST',headers:{Accept:'application/json'},body});
        const added=await response.json();if(!response.ok||added.status)throw new Error(added.description||added.message||'Could not add your selection. Please try again.');
        const cartResponse=await fetch(`${base}cart.js`,{headers:{Accept:'application/json'}});
        if(!cartResponse.ok)throw new Error('Added to your cart. Open the cart to review your order.');
        const cart=await cartResponse.json();
        document.dispatchEvent(new CartAddEvent(cart,String(variant.id),{source:'product-form-component',productId:root.dataset.product,itemCount:quantity,sections:added.sections}));
        const matching=cart.items.filter(item=>String(item.variant_id)===String(variant.id)&&!item.selling_plan_allocation);
        const count=matching.reduce((sum,item)=>sum+item.quantity,0);
        const actual=matching.reduce((sum,item)=>sum+item.final_line_price,0);
        if(count===quantity && Math.abs(actual-variant.price*paid(quantity))>1){
          error.textContent='Your items are in the cart, but the bundle discount could not be confirmed. Please review the actual cart total before checkout or contact support.';error.hidden=false;
        }
        const drawer=document.querySelector('cart-drawer-component');
        if(drawer?.open)drawer.open();
        else if(drawer?.showDialog)drawer.showDialog();
        else {error.innerHTML='Added to your cart. <a href="'+base+'cart">View cart</a>';error.hidden=false;}
      } catch(e){error.textContent=e.message||'Something went wrong. Please try again.';error.hidden=false;}
      finally{busy=false;sync();}
    });
  });
  const gallery=root.querySelector('[data-lc-gallery]');
  const thumbnails=[...root.querySelectorAll('[data-lc-thumb]')];
  const galleryIndex=()=>Math.round(gallery.scrollLeft/gallery.clientWidth);
  const goImage=index=>gallery.scrollTo({left:Math.max(0,Math.min(thumbnails.length-1,index))*gallery.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  thumbnails.forEach(button=>listen(button,'click',()=>goImage(Number(button.dataset.lcThumb))));
  root.querySelectorAll('[data-lc-gallery-dir]').forEach(button=>listen(button,'click',()=>goImage(galleryIndex()+Number(button.dataset.lcGalleryDir))));
  listen(gallery,'scroll',()=>thumbnails.forEach((button,index)=>button.setAttribute('aria-current',String(index===galleryIndex()))),{passive:true});
  listen(gallery,'keydown',event=>{if(['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();goImage(galleryIndex()+(event.key==='ArrowRight'?1:-1));}});
  all('[data-lc-slider]').forEach(slider=>{
    const track=slider.querySelector('.lc-review-track');const cards=[...track.children];
    const dots=slider.querySelector('.lc-slider-dots');
    if(!cards.length){slider.hidden=true;return;}
    let positions=[];
    const behavior=()=>matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth';
    const update=()=>{
      const index=positions.reduce((best,x,i)=>Math.abs(x-track.scrollLeft)<Math.abs(positions[best]-track.scrollLeft)?i:best,0);
      [...dots.children].forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index)));
      slider.querySelector('[data-lc-slide="-1"]').disabled=track.scrollLeft<2;
      slider.querySelector('[data-lc-slide="1"]').disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2;
    };
    const measure=()=>{
      const maximum=Math.max(0,track.scrollWidth-track.clientWidth);
      positions=[...new Set(cards.map(card=>Math.min(maximum,card.offsetLeft-cards[0].offsetLeft)))];
      dots.replaceChildren();
      positions.forEach((left,i)=>{const dot=document.createElement('button');dot.type='button';dot.setAttribute('aria-label',`Review page ${i+1}`);listen(dot,'click',()=>track.scrollTo({left,behavior:behavior()}));dots.append(dot);});
      update();
    };
    slider.querySelectorAll('[data-lc-slide]').forEach(button=>listen(button,'click',()=>{
      const step=cards[1]?cards[1].offsetLeft-cards[0].offsetLeft:track.clientWidth;
      track.scrollBy({left:Number(button.dataset.lcSlide)*step,behavior:behavior()});
    }));
    listen(track,'scroll',update,{passive:true});
    const observer=new ResizeObserver(measure);observer.observe(track);
    signal.addEventListener('abort',()=>observer.disconnect(),{once:true});measure();
  });
  const sticky=root.querySelector('[data-lc-sticky]');
  const topButton=root.querySelector('[data-lc-atc]');
  const updateSticky=()=>{
    const hasPassed=topButton.getBoundingClientRect().bottom<0;
    const visible=all('[data-lc-atc]').some(button=>{const r=button.getBoundingClientRect();return r.bottom>0&&r.top<innerHeight;});
    sticky.hidden=!hasPassed||visible||innerWidth>=768||!!document.querySelector('cart-drawer-component dialog[open]');
  };
  listen(window,'scroll',updateSticky,{passive:true});listen(window,'resize',updateSticky,{passive:true});
  listen(document,'dialog:open',updateSticky);listen(document,'dialog:close',updateSticky);
  listen(root.querySelector('[data-lc-sticky-button]'),'click',()=>root.querySelector('[data-lc-form]').requestSubmit());
  const urgency=root.querySelector('[data-lc-urgency]');
  if(urgency?.dataset.deadline){const end=Date.parse(urgency.dataset.deadline);const label=urgency.querySelector('[data-lc-countdown]');const tick=()=>{const remaining=Math.max(0,Math.floor((end-Date.now())/1000));if(!Number.isFinite(end)||remaining===0){urgency.hidden=true;return;}label.hidden=false;label.textContent=`ENDS IN ${String(Math.floor(remaining/3600)).padStart(2,'0')}:${String(Math.floor(remaining%3600/60)).padStart(2,'0')}:${String(remaining%60).padStart(2,'0')}`;};tick();const timer=setInterval(tick,1000);signal.addEventListener('abort',()=>clearInterval(timer),{once:true});}
  sync();updateSticky();
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
document.addEventListener('shopify:section:load',initialize);
document.addEventListener('shopify:section:unload',initialize);
